import React from 'react';
import { Navigate } from 'react-router-dom';
import useSession from '#/common/hooks/useSession';
import { UserRole } from '#/common/types/userTypes';

const TechnicianRedirect: React.FC = () => {
  const { user } = useSession();

  if (!!user && user.role === UserRole.technician && user.name) {
    // Redirect technicians to their assigned work orders
    const filters = ['assignedToId', '=', user?.id];
    const params = new URLSearchParams();
    params.set('filters', JSON.stringify(filters));
    const to = `list?${params.toString()}`;
    return <Navigate to={to} replace />;
  }

  // For all other users, redirect to standard list
  return <Navigate to="list" replace />;
};

export default TechnicianRedirect;
